import type { BuildingBlockType } from '@/stores/buildingBlock'

export type AddProductDialogCopy = {
  title: string
  subtitle: string
  searchLabel: string
  noMatchLabel: string
  emptySearchLabel: string
  addButtonLabel: string
}

export type BuildingBlockTypeCopy = {
  impactLabel: string
  addButtonLabel: string
  rowLabel: string
  rowImpactLabel: string
  nameFieldLabel: string
  newRowName: string
  addProductDialog?: AddProductDialogCopy
}

export const DEFAULT_BUILDING_BLOCK_TYPE: BuildingBlockType = 'material'

export const BUILDING_BLOCK_TYPE_COPY: Record<BuildingBlockType, BuildingBlockTypeCopy> = {
  material: {
    impactLabel: 'Material Impact',
    addButtonLabel: 'Add material',
    rowLabel: 'Material',
    rowImpactLabel: 'Material impact:',
    nameFieldLabel: 'Material name',
    newRowName: '',
    addProductDialog: {
      title: 'Add material',
      subtitle: 'Search and add a material from database to building block.',
      searchLabel: 'Enter material name',
      noMatchLabel: 'No material matching',
      emptySearchLabel: 'Type a material name to search',
      addButtonLabel: 'Add'
    }
  },
  equipment: {
    impactLabel: 'Equipment Impact',
    addButtonLabel: 'Add equipment',
    rowLabel: 'Equipment',
    rowImpactLabel: 'Equipment Impact:',
    nameFieldLabel: 'Equipment name',
    newRowName: 'New equipment'
  }
}

export const getBuildingBlockTypeCopy = (blockType?: BuildingBlockType) =>
  BUILDING_BLOCK_TYPE_COPY[blockType ?? DEFAULT_BUILDING_BLOCK_TYPE]
